export const FETCH_EMP = 'views/users/FETCH_EMP'
export const FETCH_SITE_EMP = 'views/users/FETCH_SITE_EMP'

